import { render, staticRenderFns } from "./keywords-form.html?vue&type=template&id=4285dcd6&scoped=true&"
import script from "./keywords-form.js?vue&type=script&lang=js&"
export * from "./keywords-form.js?vue&type=script&lang=js&"
import style0 from "./keywords-form.scss?vue&type=style&index=0&id=4285dcd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4285dcd6",
  null
  
)

export default component.exports